export class OTA_Address {
    public formattedInd: boolean;
    public type: number;
    public operation: string;
    public cityName: string;
    public postalCode: string;
    public countryName: string;
    public stateProv: string;
    public addressLines = new Array<string>();
}
